<div mat-dialog-content class="p-3" *ngIf="combos$ | async as combos">
  <form
    action=""
    class="grid gap-x-4 grid-cols-1 md:grid-cols-2 lg:grid-cols-2">
    <mat-form-field>
      <mat-label>Tema</mat-label>
      <mat-select
        name="tema_descripcion"
        [(ngModel)]="tema_descripcion"
        multiple>
        @for (tema of combos.catTemas; track tema) {
        <mat-option [value]="tema.id"  [disabled]="disableOption(tema_descripcion, tema.id)">{{ tema.descripcion }}</mat-option>
        }
      </mat-select>
    </mat-form-field>
    <mat-form-field>
      <mat-label>Tipo</mat-label>
      <mat-select
        name="tipo_descripcion"
        [(ngModel)]="tipo_descripcion"
        multiple>
        @for (tipo of combos.catTipos; track tipo) {
        <mat-option [value]="tipo.descripcion"  [disabled]="disableOption(tipo_descripcion, tipo.descripcion)">{{
          tipo.descripcion
        }}</mat-option>
        }
      </mat-select>
    </mat-form-field>
    <mat-form-field>
      <mat-label>Modo de entrada</mat-label>
      <mat-select
        name="modo_entrada_descripcion"
        [(ngModel)]="modo_entrada_descripcion"
        multiple>
        @for (modo of combos.catmodoEntrada; track modo) {
        <mat-option [value]="modo.descripcion" [disabled]="disableOption(modo_entrada_descripcion, modo.descripcion)">{{
          modo.descripcion
        }}</mat-option>
        }
      </mat-select>
    </mat-form-field>
    <mat-form-field>
      <mat-label>Prioridad</mat-label>
      <mat-select
        name="prioridad_descripcion"
        [(ngModel)]="prioridad_descripcion"
        multiple>
        @for (prioridad of combos.catPrioridad; track prioridad) {
        <mat-option [value]="prioridad.descripcion"  [disabled]="disableOption(prioridad_descripcion,prioridad.descripcion)">{{
          prioridad.descripcion
        }}</mat-option>
        }
      </mat-select>
    </mat-form-field>
    <mat-form-field>
      <mat-label>Remitente</mat-label>
      <mat-select
        name="remitente_descripcion"
        [(ngModel)]="remitente_descripcion"
        multiple>
        <mat-option
          *ngFor="let remitente of combos.catRemitente | orderBy : 'nombre'"
          [value]="
            remitente.nombre + ' ' + remitente.apellido + ' | ' + remitente.mail
          "
          [disabled]="disableOption(remitente_descripcion, remitente.nombre + ' ' + remitente.apellido + ' | ' + remitente.mail)"
          >{{
            remitente.nombre +
              " " +
              remitente.apellido +
              "(" +
              remitente.mail +
              ")"
          }}</mat-option
        >
      </mat-select>
    </mat-form-field>
    <mat-form-field>
      <mat-label>Delegado a</mat-label>
      <mat-select
        name="delegado_descripcion"
        [(ngModel)]="delegado_descripcion"
        multiple>
        <mat-option
          *ngFor="let remitente of combos.catRemitente | orderBy : 'nombre'"
          [value]="
            remitente.nombre + ' ' + remitente.apellido + ' | ' + remitente.mail
          "
          [disabled]="disableOption(delegado_descripcion, remitente.nombre + ' ' + remitente.apellido + ' | ' + remitente.mail)"
          >{{
            remitente.nombre +
              " " +
              remitente.apellido +
              "(" +
              remitente.mail +
              ")"
          }}</mat-option
        >
      </mat-select>
    </mat-form-field>
    <mat-form-field>
      <mat-label>Enviado a</mat-label>
      <mat-select
        name="remitente_enviado_descripcion"
        [(ngModel)]="remitente_enviado_descripcion"
        multiple>
        <mat-option
          *ngFor="let remitente of combos.catRemitente | orderBy : 'nombre'"
          [value]="
            remitente.nombre + ' ' + remitente.apellido + ' | ' + remitente.mail
          "
           [disabled]="disableOption(remitente_enviado_descripcion, remitente.nombre + ' ' + remitente.apellido + ' | ' + remitente.mail)"
          >{{
            remitente.nombre +
              " " +
              remitente.apellido +
              "(" +
              remitente.mail +
              ")"
          }}</mat-option
        >
      </mat-select>
    </mat-form-field>
    <mat-form-field>
      <mat-label>Con Copia a</mat-label>
      <mat-select
        name="conCopia_descripcion"
        [(ngModel)]="conCopia_descripcion"
        multiple>
        @for (remitente of combos.catRemitente; track remitente) {
        <mat-option
          [value]="
            remitente.nombre + ' ' + remitente.apellido + ' | ' + remitente.mail
          "
           [disabled]="disableOption(conCopia_descripcion, remitente.nombre + ' ' + remitente.apellido + ' | ' + remitente.mail)"
          >{{
            remitente.nombre +
              " " +
              remitente.apellido +
              "(" +
              remitente.mail +
              ")"
          }}</mat-option
        >
        }
      </mat-select>
    </mat-form-field>
    <mat-form-field>
      <mat-label>Empresa</mat-label>
      <mat-select
        name="empresa_descripcion"
        [(ngModel)]="empresa_descripcion"
        multiple>
        @for (empresa of combos.catEmpresas; track empresa) {
        <mat-option [value]="empresa.descripcion"  [disabled]="disableOption(empresa_descripcion,empresa.descripcion)">{{
          empresa.descripcion
        }}</mat-option>
        }
      </mat-select>
    </mat-form-field>
    <mat-form-field>
      <mat-label>Estatus de la entrada</mat-label>
      <mat-select
        name="estatus_descripcion"
        [(ngModel)]="estatus_descripcion"
        multiple>
        @for (estatus of combos.catEstatus; track estatus) {
        <mat-option [value]="estatus.descripcion"  [disabled]="disableOption(estatus_descripcion,estatus.descripcion)">{{
          estatus.descripcion
        }}</mat-option>
        }
      </mat-select>
    </mat-form-field>
    <mat-form-field>
      <mat-label>Fecha inicio (Desde)</mat-label>
      <input
        name="fechaInicioDesde"
        [(ngModel)]="fechaInicioDesde"
        matInput
        [matDatepicker]="picker1" />
      <mat-datepicker-toggle
        matIconSuffix
        [for]="picker1"></mat-datepicker-toggle>
      <mat-datepicker #picker1></mat-datepicker>
    </mat-form-field>
    <mat-form-field>
      <mat-label>Fecha fin (Desde)</mat-label>
      <input
        name="fechaFinDesde"
        [(ngModel)]="fechaFinDesde"
        matInput
        [matDatepicker]="picker3" />
      <mat-datepicker-toggle
        matIconSuffix
        [for]="picker3"></mat-datepicker-toggle>
      <mat-datepicker #picker3></mat-datepicker>
    </mat-form-field>
    <mat-form-field>
      <mat-label>Fecha inicio (Hasta)</mat-label>
      <input
        name="fechaInicioHasta"
        [(ngModel)]="fechaInicioHasta"
        matInput
        [matDatepicker]="picker2" />
      <mat-datepicker-toggle
        matIconSuffix
        [for]="picker2"></mat-datepicker-toggle>
      <mat-datepicker #picker2></mat-datepicker>
    </mat-form-field>
    <mat-form-field>
      <mat-label>Fecha fin (Hasta)</mat-label>
      <input
        name="fechaFinHasta"
        [(ngModel)]="fechaFinHasta"
        matInput
        [matDatepicker]="picker4" />
      <mat-datepicker-toggle
        matIconSuffix
        [for]="picker4"></mat-datepicker-toggle>
      <mat-datepicker #picker4></mat-datepicker>
    </mat-form-field>
  </form>
  <div class="p-3 !flex !gap-2 !justify-end !items-center">
    <button
      class="!uppercase button-orange-color"
      mat-button
      (click)="buscar(combos.idsTemas)">
      Buscar (con filtros)
    </button>
    <button
      class="!uppercase button-blue-color"
      mat-button
      (click)="resetFiltos()">
      Limpiar filtros
    </button>
  </div>
</div>
